import { Typography, Box } from "@mui/material" 
import FormDescription from '../../../inputFormComponents/FormDescription'

const DescriptionUserContact = () => {
  return (
    <FormDescription 
      paragraphs={[
        <Box key={1}>
          <Typography variant="body1">Kontakt:</Typography>
          <Typography variant="body2">Hier gibst du den Ansprechpartner für Rückfragen deines Kunden an. Der Ansprechpartner wird automatisch mit in der Rechnung aufgenommen.</Typography>
        </Box>,
      ]}
    />
  )
}

export default DescriptionUserContact